export default __webpack_public_path__ + "static/media/bg-bursa-light.918d8c87.png";